import React from 'react';
import { CustomIcon } from 'view/common';
import cx from 'classnames';
import s from './style.scss';

const Input = ({
  iconSrc, style, inputProps, dropdownVisible, dropdownOptions,
}) => {
  const dropdownOptionsList = dropdownOptions || [];
  return (
    <div
      className="inputWrapper"
      style={style}
    >
      {iconSrc && <CustomIcon src={iconSrc} height="14px" wrapperStyle={{ padding: '0 10px' }} />}
      <input {...inputProps} />
      <div className={cx(s.searchDropdown, {
        [s.visible]: dropdownVisible,
      })}
      >
        {dropdownOptionsList.map((it, ind) => (
          <div className="item" key={`${ind + 1}k`}>
            <p>{it.title}</p>
            <span>{it.note || 'Add this address'}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export { Input };



// WEBPACK FOOTER //
// ./src/view/common/Input/index.jsx